module.exports = __webpack_public_path__ + "img/tasks.0219edd5.svg";